import { BootstrapVue } from "bootstrap-vue";

export default (Vue) => {
  Vue.use(BootstrapVue);
};
